import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function Creador() {
  const revealRef = useScrollReveal();
  return <section id="creador" className="bg-carbon py-14 sm:py-[90px] px-6" data-id="element-126">
      <div ref={revealRef} className="max-w-[1060px] mx-auto reveal" data-id="element-127">
        <div className="text-center md:text-left" data-id="element-128">
          <span className="text-[11px] tracking-[5px] uppercase text-oro mb-4 block md:hidden" data-id="element-129">
            El autor detrás del método
          </span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-[320px_1fr] gap-16 items-center mt-12 text-center md:text-left" data-id="element-130">
          <div data-id="element-131">
            <img src="https://i.postimg.cc/KjHJV9G4/g-Vb-8hee-IGs67-RAVGg-Cf-O-1-min.png" alt="Hugo Otero" className="w-full h-auto object-contain rounded-md shadow-[0_40px_80px_rgba(0,0,0,0.6)] grayscale-[10%]" data-id="element-132" />
          </div>

          <div data-id="element-133">
            <span className="text-[11px] tracking-[5px] uppercase text-oro mb-4 hidden md:block" data-id="element-134">
              Sobre el creador
            </span>
            <h2 className="font-playfair text-[clamp(26px,3.5vw,40px)] font-bold mb-5" data-id="element-135">
              Hugo Otero
            </h2>
            <div className="w-[60px] h-[2px] bg-gradient-to-r from-oro to-transparent my-4 mx-auto md:mx-0" data-id="element-136"></div>

            <p className="text-[15px] text-white/70 leading-[1.85] mb-4" data-id="element-137">
              Durante años trabajé como cocinero profesional aprendiendo
              técnicas italianas de primera mano. Cuando me diagnosticaron
              celiaquía, no acepté perder la pasta. Pasé 18 meses perfeccionando
              lo que hoy es{' '}
              <strong className="text-white" data-id="element-138">El Método Italiano™</strong>: el
              sistema que me devolvió la mesa italiana sin gluten.
            </p>
            <p className="text-[15px] text-white/70 leading-[1.85] mb-4" data-id="element-139">
              Este ebook no es teoría de nutricionista. Es el resultado de
              cientos de intentos, errores documentados y ajustes precisos en
              cocina real. Cada receta fue probada con familia, amigos y
              personas celiacas que no sabían que lo que comían era diferente.
            </p>
            <p className="text-[15px] text-white/70 leading-[1.85] mb-4" data-id="element-140">
              Si yo pude construir esto desde cero, tú puedes replicarlo en tu
              cocina esta semana.
            </p>

            <div className="flex flex-wrap gap-8 mt-8 justify-center md:justify-start" data-id="element-141">
              <div className="text-center" data-id="element-142">
                <span className="font-montserrat text-[36px] font-black text-oro-claro block" data-id="element-143">
                  500+
                </span>
                <span className="text-[12px] text-white/50 uppercase tracking-[2px]" data-id="element-144">
                  Copias vendidas
                </span>
              </div>
              <div className="text-center" data-id="element-145">
                <span className="font-montserrat text-[36px] font-black text-oro-claro block" data-id="element-146">
                  12+
                </span>
                <span className="text-[12px] text-white/50 uppercase tracking-[2px]" data-id="element-147">
                  Tipos de pasta
                </span>
              </div>
              <div className="text-center" data-id="element-148">
                <span className="font-montserrat text-[36px] font-black text-oro-claro block" data-id="element-149">
                  7
                </span>
                <span className="text-[12px] text-white/50 uppercase tracking-[2px]" data-id="element-150">
                  Días de garantía
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}